import { DataBean } from "../DataBean";

export class ProcessQueue extends DataBean {

    public async getProcessQueue(idprocessqueue: number): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.ProcessQueue_getProcessQueue_Number", [idprocessqueue], { disableSpinner: true });
    }

}